import { logger } from '@axilon-apps/libs-ui-core'
import { authenticationLoginSuccess } from '../../actions/authentication-actions'
import { setCurrentUserAction, setMfaStatusAction } from '../../slices/authentication-slice'
import { generatedApi } from '../axilon-v2-api.generated'

const applySideEffectOverrides = (api: typeof generatedApi) =>
  api.enhanceEndpoints({
    endpoints: {
      login: {
        async onQueryStarted(_, { dispatch, queryFulfilled }) {
          try {
            const { data: token } = await queryFulfilled

            dispatch(authenticationLoginSuccess(token))
          } catch (error) {
            logger.error('login failed', { error })
          }
        }
      },

      sessionOidcAuthentication: {
        async onQueryStarted(_, { dispatch, queryFulfilled }) {
          try {
            const { data: token } = await queryFulfilled

            dispatch(authenticationLoginSuccess(token))
          } catch (error) {
            logger.error('sessionOidcAuthentication failed', { error })
          }
        }
      },

      getCurrentUser: {
        async onQueryStarted(_, { dispatch, queryFulfilled }) {
          try {
            const { data: currentUser } = await queryFulfilled

            dispatch(setCurrentUserAction(currentUser))
          } catch (error) {
            logger.error('getCurrentUser failed', { error })
          }
        }
      },

      updateAccountInfo: {
        async onQueryStarted(_, { dispatch, queryFulfilled }) {
          try {
            const { data } = await queryFulfilled

            dispatch(setCurrentUserAction(data))
          } catch (error) {
            logger.error('updateAccountInfo failed', { error })
          }
        }
      },

      deleteCurrentUserMfa: {
        async onQueryStarted(_, { dispatch, queryFulfilled }) {
          try {
            await queryFulfilled
            dispatch(setMfaStatusAction(false))
          } catch (error) {
            logger.error('deleteCurrentUserMfa failed', { error })
          }
        }
      }
    }
  })

export default applySideEffectOverrides
